import { mockAuthHeaders } from './mockAuth';
import { withViewAs } from './viewAs';

// Thin fetch wrapper that always sends credentials (so the onward_session
// cookie rides along), injects the X-Mock-User header when a mock user is
// stored, and tacks on `?as_user_id=...` when an admin is in view-as mode.
// Callers can still pass `headers` in options to layer on Content-Type, etc.
//
// Use this for every call to the Onward API that needs auth — plain fetch()
// doesn't send cookies on cross-origin requests by default, which is the
// whole reason the mxb env had silent 401s everywhere.
export const apiFetch = (url, options = {}) => {
  return fetch(withViewAs(url), {
    ...options,
    credentials: 'include',
    headers: {
      ...mockAuthHeaders(),
      ...(options.headers || {}),
    },
  });
};
